module.exports = __webpack_public_path__ + "img/centro-civico.d5a8006d.jpg";